import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Logo";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-ink text-offwhite" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <Wordmark />
            <p className="mt-6 text-sm leading-relaxed text-offwhite/60 max-w-sm">
              Symmori is an influencer marketing agency specialising in informational
              YouTube — connecting brands with creators who educate, explain, analyse
              and investigate.
            </p>
            <a
              href="mailto:admin@symmori.com"
              data-testid="footer-email"
              className="mt-6 inline-block text-sm text-offwhite/80 underline underline-offset-8 decoration-offwhite/30 hover:decoration-mutedblue hover:text-white transition-colors duration-300"
            >
              admin@symmori.com
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-mutedblue font-semibold">Explore</p>
            <ul className="mt-6 space-y-4 text-sm">
              <li><Link data-testid="footer-link-services" className="text-offwhite/70 hover:text-white transition-colors duration-300" to="/#services">Services</Link></li>
              <li><Link data-testid="footer-link-focus" className="text-offwhite/70 hover:text-white transition-colors duration-300" to="/#focus">Our Focus</Link></li>
              <li><Link data-testid="footer-link-about" className="text-offwhite/70 hover:text-white transition-colors duration-300" to="/#about">About</Link></li>
              <li><Link data-testid="footer-link-contact" className="text-offwhite/70 hover:text-white transition-colors duration-300" to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em] text-mutedblue font-semibold">Legal</p>
            <ul className="mt-6 space-y-4 text-sm">
              <li><Link data-testid="footer-link-privacy" className="text-offwhite/70 hover:text-white transition-colors duration-300" to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link data-testid="footer-link-anti-spam" className="text-offwhite/70 hover:text-white transition-colors duration-300" to="/anti-spam-policy">Anti-Spam &amp; Unsolicited Advertising Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-offwhite/50" data-testid="footer-copyright">
            &copy; {year} Symmori. All rights reserved.
          </p>
          <p className="text-xs text-offwhite/50">Influencer marketing for informational YouTube.</p>
        </div>
      </div>
    </footer>
  );
};
